import { PlatformOptionsType } from '../types';

export const PUBLIC_ROUTE = {
  login: '/login',
  auth0Callback: '/auth0/callback',
  notFound: '/404',
  connectedKOLSocialAccount: '/kol-connected-social-account-success',
  successfulEmailVerification: '/successful-email-verification',
  tokenExpired: '/expired-merchant-tọken',
  xhsAccountVerification: '/submit-account-verification',
  campaignLanding: '/c/:campaign_name',
  sharedCampaign: '/shared',
};

export const PRIVATE_ROUTE = {
  dashboard: '/dashboard',
  pendingReview: '/pending-review',
  accountUnavailable: '/account-unavailable',
  merchantRegister: '/merchant-register',
  campaigns: '/campaigns',
  campaignsOfProfile: '/campaigns-of-merchant/:kol_profile_id',
  campaignsCreate: '/campaigns/create',
  campaignsDetails: '/campaigns/:id/details',
  campaignsListOfKols: '/campaigns/:id/list-of-kols',
  campaignsChat: '/campaigns/:id/list-of-kols/chat/:contractID',
  // Campaign-wide board of every submitted deliverable (KA-1941). Distinct from
  // `campaignsDeliverables` below, which is one KOL's deliverables on their contract.
  campaignsDeliverablesBoard: '/campaigns/:id/deliverables',
  campaignsDeliverables: '/campaigns/:id/list-of-kols/deliverables/:contractID',
  campaignsReport: '/campaigns/:id/campaign-report',
  paymentConfig: '/payment-config/:id',
  campaignConfig: '/campaign-config/:id',
  companyProfile: '/company-profile',
  userProfile: '/user-profile',
  wallet: '/wallet',
  contentMetrics: '/campaigns/:id/:kol_profile_id/content-metrics',
  publishCampaignTerms: '/publish-campaign-terms',
  teams: '/teams',
  selectMerchant: '/select-merchant',
  clientRegister: '/client-register',
  kolProfile: '/kols/:id',
};

export const ROUTES = {
  ...PUBLIC_ROUTE,
  ...PRIVATE_ROUTE,
};

export const DEFAULT_AVATAR = '/static/images/campaigns/user.png';
export const DEFAULT_AVATAR_MOBILE = '/static/images/campaigns/profile.png';

export const MESSAGE_APPROVAL_REQUEST = {
  approved: 'APPROVED',
  rejected: 'REJECTED',
  pending: 'PENDING',
};

export const VIEW_MODE = {
  list: 0,
  grid: 1,
};

export const MODE = {
  view: '0',
  edit: '1',
};

export const amountArray = [500, 2500, 5000];

export const platformOptions: PlatformOptionsType[] = [
  {
    value: 'ig_',
    name: 'Instagram',
  },
  {
    value: 'tt_',
    name: 'TikTok',
  },
  {
    value: 'xhs_',
    name: 'Xiaohongshu',
  },
  {
    value: 'l8_',
    name: 'Lemon8',
  },
  {
    value: 'youtube_',
    name: 'YouTube',
  },
  {
    value: 'fb_',
    name: 'Facebook',
  },
  {
    value: 'others',
    name: 'Others',
  },
];

export const platformCodes: string[] = ['ig_', 'tt_', 'xhs_', 'l8_', 'youtube_', 'fb_'];

export const INSTAGRAM_PLATFORM_NAME = 'INSTAGRAM';
export const TIKTOK_PLATFORM_NAME = 'TIKTOK';
export const TWITTER_PLATFORM_NAME = 'TWITTER';
export const FACEBOOK_PLATFORM_NAME = 'FACEBOOK';
export const YOUTUBE_PLATFORM_NAME = 'YOUTUBE';
export const LEMON8_PLATFORM_NAME = 'LEMON8';
export const XIAOHONGSHU_PLATFORM_NAME = 'XIAOHONGSHU';

export const DAY_FORMAT = 'dd MMM yyyy';

export const DATE_TIME_FORMAT = 'dd MMM yyyy, hh:mm a';
